// THIS IS A GENERATED FILE
import * as Types from "../../graphql/types"

import gql from "graphql-tag"
import * as ApolloReactCommon from "@apollo/react-common"
import * as ApolloReactHooks from "@apollo/react-hooks"

export type HostingDetailsForSiteQueryVariables = Types.Exact<{
  siteId: Types.Scalars["UUID"]
}>

export type HostingDetailsForSiteQuery = { __typename?: "Query" } & {
  hostingDetailsForSite?: Types.Maybe<
    Array<
      Types.Maybe<
        { __typename?: "HostingDetails" } & Pick<Types.HostingDetails, "id"> & {
            domains?: Types.Maybe<
              Array<
                Types.Maybe<
                  { __typename?: "HostingDomain" } & Pick<
                    Types.HostingDomain,
                    | "id"
                    | "verified"
                    | "verificationMessage"
                    | "errorMessage"
                    | "cloudCdnDefault"
                    | "certificateStatus"
                    | "primaryDomainId"
                  > & {
                      dns?: Types.Maybe<
                        Array<
                          Types.Maybe<
                            { __typename?: "HostingDnsInfo" } & Pick<
                              Types.HostingDnsInfo,
                              "id" | "type"
                            >
                          >
                        >
                      >
                    }
                >
              >
            >
            certificates?: Types.Maybe<
              Array<
                Types.Maybe<
                  { __typename?: "HostingCertificate" } & Pick<
                    Types.HostingCertificate,
                    | "id"
                    | "createdAt"
                    | "notAfter"
                    | "notBefore"
                    | "issuer"
                    | "issuedTo"
                    | "canDelete"
                    | "managed"
                    | "serialNumber"
                    | "errors"
                  > & {
                      domains?: Types.Maybe<
                        Array<
                          Types.Maybe<
                            { __typename?: "HostingCertificateDomain" } & Pick<
                              Types.HostingCertificateDomain,
                              "id"
                            >
                          >
                        >
                      >
                    }
                >
              >
            >
            dns?: Types.Maybe<
              Array<
                Types.Maybe<
                  { __typename?: "HostingDnsInfo" } & Pick<
                    Types.HostingDnsInfo,
                    "id" | "type"
                  >
                >
              >
            >
          }
      >
    >
  >
}

export type ConnectCloudCdnToSiteMutationVariables = Types.Exact<{
  siteId: Types.Scalars["UUID"]
}>

export type ConnectCloudCdnToSiteMutation = { __typename?: "Mutation" } & {
  connectCloudCdnToSite?: Types.Maybe<
    { __typename?: "MutationResult" } & Pick<
      Types.MutationResult,
      "success" | "message" | "errorType"
    >
  >
}

export type AddCloudCdnDomainMutationVariables = Types.Exact<{
  domainName: Types.Scalars["String"]
  siteId: Types.Scalars["UUID"]
}>

export type AddCloudCdnDomainMutation = { __typename?: "Mutation" } & {
  addCloudCdnDomain?: Types.Maybe<
    { __typename?: "MutationResult" } & Pick<
      Types.MutationResult,
      "success" | "message" | "errorType"
    >
  >
}

export type RemoveCloudCdnDomainMutationVariables = Types.Exact<{
  domainName: Types.Scalars["String"]
  siteId: Types.Scalars["UUID"]
}>

export type RemoveCloudCdnDomainMutation = { __typename?: "Mutation" } & {
  removeCloudCdnDomain?: Types.Maybe<
    { __typename?: "MutationResult" } & Pick<
      Types.MutationResult,
      "success" | "message" | "errorType"
    >
  >
}

export type UpsertCloudCdnCertificateMutationVariables = Types.Exact<{
  siteId: Types.Scalars["UUID"]
  tlsKey: Types.Scalars["String"]
  tlsCert: Types.Scalars["String"]
  tlsIntermediateCerts?: Types.Maybe<Types.Scalars["String"]>
}>

export type UpsertCloudCdnCertificateMutation = { __typename?: "Mutation" } & {
  upsertCloudCdnCertificate?: Types.Maybe<
    { __typename?: "MutationResult" } & Pick<
      Types.MutationResult,
      "success" | "message" | "errorType"
    >
  >
}

export type RemoveCloudCdnCertificateMutationVariables = Types.Exact<{
  id: Types.Scalars["String"]
  siteId: Types.Scalars["UUID"]
}>

export type RemoveCloudCdnCertificateMutation = { __typename?: "Mutation" } & {
  removeCloudCdnCertificate?: Types.Maybe<
    { __typename?: "MutationResult" } & Pick<
      Types.MutationResult,
      "success" | "message" | "errorType"
    >
  >
}

export type VerifyCloudCdnDomainMutationVariables = Types.Exact<{
  domainName: Types.Scalars["String"]
  siteId: Types.Scalars["UUID"]
}>

export type VerifyCloudCdnDomainMutation = { __typename?: "Mutation" } & {
  verifyCloudCdnDomain?: Types.Maybe<
    { __typename?: "MutationResult" } & Pick<
      Types.MutationResult,
      "success" | "message" | "errorType"
    >
  >
}

export type SetCloudCdnDomainAsPrimaryMutationVariables = Types.Exact<{
  domainName: Types.Scalars["String"]
  siteId: Types.Scalars["UUID"]
}>

export type SetCloudCdnDomainAsPrimaryMutation = { __typename?: "Mutation" } & {
  setCloudCdnDomainAsPrimary?: Types.Maybe<
    { __typename?: "MutationResult" } & Pick<
      Types.MutationResult,
      "success" | "message" | "errorType"
    >
  >
}

export type RequestCloudCdnCertificateMutationVariables = Types.Exact<{
  domainName: Types.Scalars["String"]
  siteId: Types.Scalars["UUID"]
}>

export type RequestCloudCdnCertificateMutation = { __typename?: "Mutation" } & {
  requestCloudCdnCertificate?: Types.Maybe<
    { __typename?: "MutationResult" } & Pick<
      Types.MutationResult,
      "success" | "message" | "errorType"
    >
  >
}

export const HostingDetailsForSiteDocument = gql`
  query HostingDetailsForSite($siteId: UUID!) {
    hostingDetailsForSite(siteId: $siteId) {
      id
      domains {
        id
        verified
        verificationMessage
        errorMessage
        dns {
          id
          type
        }
        cloudCdnDefault
        certificateStatus
        primaryDomainId
      }
      certificates {
        id
        createdAt
        notAfter
        notBefore
        issuer
        issuedTo
        domains {
          id
        }
        canDelete
        managed
        serialNumber
        errors
      }
      dns {
        id
        type
      }
    }
  }
`

/**
 * __useHostingDetailsForSiteQuery__
 *
 * To run a query within a React component, call `useHostingDetailsForSiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useHostingDetailsForSiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHostingDetailsForSiteQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useHostingDetailsForSiteQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    HostingDetailsForSiteQuery,
    HostingDetailsForSiteQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    HostingDetailsForSiteQuery,
    HostingDetailsForSiteQueryVariables
  >(HostingDetailsForSiteDocument, baseOptions)
}
export function useHostingDetailsForSiteLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    HostingDetailsForSiteQuery,
    HostingDetailsForSiteQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    HostingDetailsForSiteQuery,
    HostingDetailsForSiteQueryVariables
  >(HostingDetailsForSiteDocument, baseOptions)
}
export type HostingDetailsForSiteQueryHookResult = ReturnType<
  typeof useHostingDetailsForSiteQuery
>
export type HostingDetailsForSiteLazyQueryHookResult = ReturnType<
  typeof useHostingDetailsForSiteLazyQuery
>
export type HostingDetailsForSiteQueryResult = ApolloReactCommon.QueryResult<
  HostingDetailsForSiteQuery,
  HostingDetailsForSiteQueryVariables
>
export const ConnectCloudCdnToSiteDocument = gql`
  mutation ConnectCloudCdnToSite($siteId: UUID!) {
    connectCloudCdnToSite(siteId: $siteId) {
      success
      message
      errorType
    }
  }
`
export type ConnectCloudCdnToSiteMutationFn = ApolloReactCommon.MutationFunction<
  ConnectCloudCdnToSiteMutation,
  ConnectCloudCdnToSiteMutationVariables
>

/**
 * __useConnectCloudCdnToSiteMutation__
 *
 * To run a mutation, you first call `useConnectCloudCdnToSiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectCloudCdnToSiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectCloudCdnToSiteMutation, { data, loading, error }] = useConnectCloudCdnToSiteMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useConnectCloudCdnToSiteMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ConnectCloudCdnToSiteMutation,
    ConnectCloudCdnToSiteMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    ConnectCloudCdnToSiteMutation,
    ConnectCloudCdnToSiteMutationVariables
  >(ConnectCloudCdnToSiteDocument, baseOptions)
}
export type ConnectCloudCdnToSiteMutationHookResult = ReturnType<
  typeof useConnectCloudCdnToSiteMutation
>
export type ConnectCloudCdnToSiteMutationResult = ApolloReactCommon.MutationResult<
  ConnectCloudCdnToSiteMutation
>
export type ConnectCloudCdnToSiteMutationOptions = ApolloReactCommon.BaseMutationOptions<
  ConnectCloudCdnToSiteMutation,
  ConnectCloudCdnToSiteMutationVariables
>
export const AddCloudCdnDomainDocument = gql`
  mutation AddCloudCdnDomain($domainName: String!, $siteId: UUID!) {
    addCloudCdnDomain(domainName: $domainName, siteId: $siteId) {
      success
      message
      errorType
    }
  }
`
export type AddCloudCdnDomainMutationFn = ApolloReactCommon.MutationFunction<
  AddCloudCdnDomainMutation,
  AddCloudCdnDomainMutationVariables
>

/**
 * __useAddCloudCdnDomainMutation__
 *
 * To run a mutation, you first call `useAddCloudCdnDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCloudCdnDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCloudCdnDomainMutation, { data, loading, error }] = useAddCloudCdnDomainMutation({
 *   variables: {
 *      domainName: // value for 'domainName'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useAddCloudCdnDomainMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AddCloudCdnDomainMutation,
    AddCloudCdnDomainMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    AddCloudCdnDomainMutation,
    AddCloudCdnDomainMutationVariables
  >(AddCloudCdnDomainDocument, baseOptions)
}
export type AddCloudCdnDomainMutationHookResult = ReturnType<
  typeof useAddCloudCdnDomainMutation
>
export type AddCloudCdnDomainMutationResult = ApolloReactCommon.MutationResult<
  AddCloudCdnDomainMutation
>
export type AddCloudCdnDomainMutationOptions = ApolloReactCommon.BaseMutationOptions<
  AddCloudCdnDomainMutation,
  AddCloudCdnDomainMutationVariables
>
export const RemoveCloudCdnDomainDocument = gql`
  mutation RemoveCloudCdnDomain($domainName: String!, $siteId: UUID!) {
    removeCloudCdnDomain(domainName: $domainName, siteId: $siteId) {
      success
      message
      errorType
    }
  }
`
export type RemoveCloudCdnDomainMutationFn = ApolloReactCommon.MutationFunction<
  RemoveCloudCdnDomainMutation,
  RemoveCloudCdnDomainMutationVariables
>

/**
 * __useRemoveCloudCdnDomainMutation__
 *
 * To run a mutation, you first call `useRemoveCloudCdnDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCloudCdnDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCloudCdnDomainMutation, { data, loading, error }] = useRemoveCloudCdnDomainMutation({
 *   variables: {
 *      domainName: // value for 'domainName'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useRemoveCloudCdnDomainMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RemoveCloudCdnDomainMutation,
    RemoveCloudCdnDomainMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    RemoveCloudCdnDomainMutation,
    RemoveCloudCdnDomainMutationVariables
  >(RemoveCloudCdnDomainDocument, baseOptions)
}
export type RemoveCloudCdnDomainMutationHookResult = ReturnType<
  typeof useRemoveCloudCdnDomainMutation
>
export type RemoveCloudCdnDomainMutationResult = ApolloReactCommon.MutationResult<
  RemoveCloudCdnDomainMutation
>
export type RemoveCloudCdnDomainMutationOptions = ApolloReactCommon.BaseMutationOptions<
  RemoveCloudCdnDomainMutation,
  RemoveCloudCdnDomainMutationVariables
>
export const UpsertCloudCdnCertificateDocument = gql`
  mutation UpsertCloudCdnCertificate(
    $siteId: UUID!
    $tlsKey: String!
    $tlsCert: String!
    $tlsIntermediateCerts: String
  ) {
    upsertCloudCdnCertificate(
      siteId: $siteId
      tlsKey: $tlsKey
      tlsCert: $tlsCert
      tlsIntermediateCerts: $tlsIntermediateCerts
    ) {
      success
      message
      errorType
    }
  }
`
export type UpsertCloudCdnCertificateMutationFn = ApolloReactCommon.MutationFunction<
  UpsertCloudCdnCertificateMutation,
  UpsertCloudCdnCertificateMutationVariables
>

/**
 * __useUpsertCloudCdnCertificateMutation__
 *
 * To run a mutation, you first call `useUpsertCloudCdnCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCloudCdnCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCloudCdnCertificateMutation, { data, loading, error }] = useUpsertCloudCdnCertificateMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      tlsKey: // value for 'tlsKey'
 *      tlsCert: // value for 'tlsCert'
 *      tlsIntermediateCerts: // value for 'tlsIntermediateCerts'
 *   },
 * });
 */
export function useUpsertCloudCdnCertificateMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpsertCloudCdnCertificateMutation,
    UpsertCloudCdnCertificateMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    UpsertCloudCdnCertificateMutation,
    UpsertCloudCdnCertificateMutationVariables
  >(UpsertCloudCdnCertificateDocument, baseOptions)
}
export type UpsertCloudCdnCertificateMutationHookResult = ReturnType<
  typeof useUpsertCloudCdnCertificateMutation
>
export type UpsertCloudCdnCertificateMutationResult = ApolloReactCommon.MutationResult<
  UpsertCloudCdnCertificateMutation
>
export type UpsertCloudCdnCertificateMutationOptions = ApolloReactCommon.BaseMutationOptions<
  UpsertCloudCdnCertificateMutation,
  UpsertCloudCdnCertificateMutationVariables
>
export const RemoveCloudCdnCertificateDocument = gql`
  mutation RemoveCloudCdnCertificate($id: String!, $siteId: UUID!) {
    removeCloudCdnCertificate(id: $id, siteId: $siteId) {
      success
      message
      errorType
    }
  }
`
export type RemoveCloudCdnCertificateMutationFn = ApolloReactCommon.MutationFunction<
  RemoveCloudCdnCertificateMutation,
  RemoveCloudCdnCertificateMutationVariables
>

/**
 * __useRemoveCloudCdnCertificateMutation__
 *
 * To run a mutation, you first call `useRemoveCloudCdnCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCloudCdnCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCloudCdnCertificateMutation, { data, loading, error }] = useRemoveCloudCdnCertificateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useRemoveCloudCdnCertificateMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RemoveCloudCdnCertificateMutation,
    RemoveCloudCdnCertificateMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    RemoveCloudCdnCertificateMutation,
    RemoveCloudCdnCertificateMutationVariables
  >(RemoveCloudCdnCertificateDocument, baseOptions)
}
export type RemoveCloudCdnCertificateMutationHookResult = ReturnType<
  typeof useRemoveCloudCdnCertificateMutation
>
export type RemoveCloudCdnCertificateMutationResult = ApolloReactCommon.MutationResult<
  RemoveCloudCdnCertificateMutation
>
export type RemoveCloudCdnCertificateMutationOptions = ApolloReactCommon.BaseMutationOptions<
  RemoveCloudCdnCertificateMutation,
  RemoveCloudCdnCertificateMutationVariables
>
export const VerifyCloudCdnDomainDocument = gql`
  mutation VerifyCloudCdnDomain($domainName: String!, $siteId: UUID!) {
    verifyCloudCdnDomain(domainName: $domainName, siteId: $siteId) {
      success
      message
      errorType
    }
  }
`
export type VerifyCloudCdnDomainMutationFn = ApolloReactCommon.MutationFunction<
  VerifyCloudCdnDomainMutation,
  VerifyCloudCdnDomainMutationVariables
>

/**
 * __useVerifyCloudCdnDomainMutation__
 *
 * To run a mutation, you first call `useVerifyCloudCdnDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyCloudCdnDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyCloudCdnDomainMutation, { data, loading, error }] = useVerifyCloudCdnDomainMutation({
 *   variables: {
 *      domainName: // value for 'domainName'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useVerifyCloudCdnDomainMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    VerifyCloudCdnDomainMutation,
    VerifyCloudCdnDomainMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    VerifyCloudCdnDomainMutation,
    VerifyCloudCdnDomainMutationVariables
  >(VerifyCloudCdnDomainDocument, baseOptions)
}
export type VerifyCloudCdnDomainMutationHookResult = ReturnType<
  typeof useVerifyCloudCdnDomainMutation
>
export type VerifyCloudCdnDomainMutationResult = ApolloReactCommon.MutationResult<
  VerifyCloudCdnDomainMutation
>
export type VerifyCloudCdnDomainMutationOptions = ApolloReactCommon.BaseMutationOptions<
  VerifyCloudCdnDomainMutation,
  VerifyCloudCdnDomainMutationVariables
>
export const SetCloudCdnDomainAsPrimaryDocument = gql`
  mutation SetCloudCdnDomainAsPrimary($domainName: String!, $siteId: UUID!) {
    setCloudCdnDomainAsPrimary(domainName: $domainName, siteId: $siteId) {
      success
      message
      errorType
    }
  }
`
export type SetCloudCdnDomainAsPrimaryMutationFn = ApolloReactCommon.MutationFunction<
  SetCloudCdnDomainAsPrimaryMutation,
  SetCloudCdnDomainAsPrimaryMutationVariables
>

/**
 * __useSetCloudCdnDomainAsPrimaryMutation__
 *
 * To run a mutation, you first call `useSetCloudCdnDomainAsPrimaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCloudCdnDomainAsPrimaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCloudCdnDomainAsPrimaryMutation, { data, loading, error }] = useSetCloudCdnDomainAsPrimaryMutation({
 *   variables: {
 *      domainName: // value for 'domainName'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useSetCloudCdnDomainAsPrimaryMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SetCloudCdnDomainAsPrimaryMutation,
    SetCloudCdnDomainAsPrimaryMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    SetCloudCdnDomainAsPrimaryMutation,
    SetCloudCdnDomainAsPrimaryMutationVariables
  >(SetCloudCdnDomainAsPrimaryDocument, baseOptions)
}
export type SetCloudCdnDomainAsPrimaryMutationHookResult = ReturnType<
  typeof useSetCloudCdnDomainAsPrimaryMutation
>
export type SetCloudCdnDomainAsPrimaryMutationResult = ApolloReactCommon.MutationResult<
  SetCloudCdnDomainAsPrimaryMutation
>
export type SetCloudCdnDomainAsPrimaryMutationOptions = ApolloReactCommon.BaseMutationOptions<
  SetCloudCdnDomainAsPrimaryMutation,
  SetCloudCdnDomainAsPrimaryMutationVariables
>
export const RequestCloudCdnCertificateDocument = gql`
  mutation RequestCloudCdnCertificate($domainName: String!, $siteId: UUID!) {
    requestCloudCdnCertificate(domainName: $domainName, siteId: $siteId) {
      success
      message
      errorType
    }
  }
`
export type RequestCloudCdnCertificateMutationFn = ApolloReactCommon.MutationFunction<
  RequestCloudCdnCertificateMutation,
  RequestCloudCdnCertificateMutationVariables
>

/**
 * __useRequestCloudCdnCertificateMutation__
 *
 * To run a mutation, you first call `useRequestCloudCdnCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestCloudCdnCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestCloudCdnCertificateMutation, { data, loading, error }] = useRequestCloudCdnCertificateMutation({
 *   variables: {
 *      domainName: // value for 'domainName'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useRequestCloudCdnCertificateMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RequestCloudCdnCertificateMutation,
    RequestCloudCdnCertificateMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    RequestCloudCdnCertificateMutation,
    RequestCloudCdnCertificateMutationVariables
  >(RequestCloudCdnCertificateDocument, baseOptions)
}
export type RequestCloudCdnCertificateMutationHookResult = ReturnType<
  typeof useRequestCloudCdnCertificateMutation
>
export type RequestCloudCdnCertificateMutationResult = ApolloReactCommon.MutationResult<
  RequestCloudCdnCertificateMutation
>
export type RequestCloudCdnCertificateMutationOptions = ApolloReactCommon.BaseMutationOptions<
  RequestCloudCdnCertificateMutation,
  RequestCloudCdnCertificateMutationVariables
>
